<ul class="no-bullets trigger-info-list"
    *uiContentLoading="loading$ | async; diameter: 75">
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_task_id' | translate }}</span>
        <span class="value">{{ item?.id }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_task_title' | translate }}</span>
        <span class="value">{{ item?.title }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_task_status' | translate }}</span>
        <span class="value">{{ item?.status }}</span>
    </li>
    <li class="trigger-info"
        *ngIf="item?.status != TaskStatus[TaskStatus.Unassigned]">
        <span class="label">{{ 'job_trigger_detail_task_assigned_to' | translate }}</span>
        <span class="value">{{ item?.assignedToUser?.userName }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_task_priority' | translate }}</span>
        <span class="value">{{ item?.taskPriority }}</span>
    </li>
    <li class="trigger-info">
        <span class="label">{{ 'job_trigger_detail_task_created' | translate }}</span>
        <span class="value">
            <ui-dateformat [date]="item?.creationTime"
                           contentType="relative">
            </ui-dateformat>
        </span>
    </li>
</ul>
